// extracted by mini-css-extract-plugin
export default {"icon":"r9BfUeueez8qAuslPI6L"};
    if(module.hot) {
      // 1647894309368
      var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  